import gql from 'graphql-tag'

export const LOGOUT_QUERY = gql`
  query logout {
    logout {
      response
    }
  }
`
